import React from "react";

// 改行をbrに変換
const nl2br = (text) => {
  if (!text) {
    return null;
  }

  const regex = /[\n\r]/g;
  return text.split(regex).map((line, key) => {
    return (
      <React.Fragment key={key}>
        {line}
        <br />
      </React.Fragment>
    );
  });
};

export default nl2br;
